import { ButtonElement } from '@typedream/core';
import { memo } from 'react';
import Image from 'next/image';
import { setNodes } from '@udecode/plate-core';
import { BUTTON_DEFAULTS } from '@typedream/components';
import { Dropdown, DropdownItem } from '../../../../components/Dropdown';
import { useTPlateEditorRef } from '../../../../plate';
import { setButtonStyle } from '../../../../nodes/button/transforms';
import { getSelectedElementEntry } from '../../../../plugins/elementSelection';
import { useDreamEditorStore } from '../../../../plugins/store';
import toolbarStyles from '../../SideToolbar.module.css';
import styles from './ButtonStyle.module.css';
import glowingButtonPreview from '../../../../../assets/images/glowing_button_preview.png';
import solidButtonPreview from '../../../../../assets/images/solid_button_preview.png';

const BUTTON_STYLES = {
  plain: 'Solid Button',
  glowing_button: 'Glowing Button',
};
const styleOptions: ButtonElement['style'][] = ['plain', 'glowing_button'];
const defaultStyle = styleOptions[0];

function ButtonStyle() {
  const editor = useTPlateEditorRef();

  const currentStyle = useDreamEditorStore(() => {
    const entry = getSelectedElementEntry<ButtonElement>(editor);
    return entry?.[0].style || defaultStyle;
  });

  return (
    <div className={toolbarStyles.section}>
      <span className={toolbarStyles.label}>Button Style</span>
      <Dropdown
        triggerLabel={
          <div className="is-capitalized">
            {currentStyle === 'glowing_button' ? BUTTON_STYLES.glowing_button : BUTTON_STYLES.plain}
          </div>
        }
      >
        {styleOptions.map((s) => (
          <DropdownItem
            key={s === 'glowing_button' ? BUTTON_STYLES.glowing_button : BUTTON_STYLES.plain}
          >
            <div
              role="none"
              className="is-flex is-align-items-center is-capitalized"
              onClick={() => {
                const path = getSelectedElementEntry(editor)?.[1];
                if (path) {
                  setButtonStyle(editor, path, s);
                  setNodes(
                    editor,
                    { box_shadow: s === 'glowing_button' ? 'none' : BUTTON_DEFAULTS.boxShadow },
                    { at: path }
                  );
                }
              }}
            >
              <div className={styles.styleShowcase}>
                <Image
                  src={s === 'glowing_button' ? glowingButtonPreview : solidButtonPreview}
                  alt="Button Preview"
                  width={40}
                  height={30}
                />
              </div>
              <span>
                {s === 'glowing_button' ? BUTTON_STYLES.glowing_button : BUTTON_STYLES.plain}
              </span>
            </div>
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
}

export default memo(ButtonStyle);
